export const isOSX = window.navigator.userAgent.includes('Mac');
